export default __webpack_public_path__ + "static/media/landmarks.c85f4f02.svg";